import AWS from "aws-sdk";
const s3 = new AWS.S3({
  endpoint: process.env.REACT_APP_ENDPOINT,
  accessKeyId: process.env.REACT_APP_ACCESSKEYID,
  secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY,
});

export default s3;
